<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © برنامج توثيق التعليمي.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    تصميم <a href="https://mohtaref.com/" target="_blank" class="text-reset">حلول محترف</a>
                </div>
            </div>
        </div>
    </div>
</footer>